import { render } from "./relatorio-fiscal.vue?vue&type=template&id=dbe66b76"
import script from "./relatorio-fiscal.vue?vue&type=script&lang=js"
export * from "./relatorio-fiscal.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__